import { useLocation } from "react-router-dom";

import isSiteRequiredForPath from "~/helpers/siteRequiredRoutes";

const useIsSiteRequiredRoute = (): boolean => {
	const location = useLocation();
	return isSiteRequiredForPath(location.pathname);
};

export default useIsSiteRequiredRoute;
